export const text = `
GOAL: All bereaved are to have adequate support systems, coping skills, and the ability to verbalize an understanding of the grief process. 
Please see Notes for any individual goals each bereaved person may have.
`;

export const riskLevel = 'riskLevel';
export const bereaveStartDate = 'bereaveStartDate';
